// 현재 날짜를 기준으로 현재 달의 마지막 날짜를 구하기
let currentDate = new Date();
let currentDay = currentDate.getDate();
let currentMonth = currentDate.getMonth() + 1;
let currentYear = currentDate.getFullYear();
let viewMonth = currentMonth; //화면에 보여줄 month

//GET 방식으로 온 month 매개변수 확인
let url = new URL(top.window.location.href);
let urlParams = new URLSearchParams(url.search);
let monthValue = urlParams.get('month');

//year month 결정
if(!!monthValue){
    //년(year) 결정
    currentYear = currentMonth > monthValue ? parseInt(currentYear+1) : currentYear;
    viewMonth = monthValue;    
}

/**
 * 해당 달의 마지막 날짜 구하기
 * @param {int} month 
 * @param {int} year 
 * @returns int
 */
let daysInMonth = function (month, year) {
    return new Date(year, month, 0).getDate();
}

/**
 * 입력 받은 달을 시작으로 달 순서 생성 1~12월
 * @param {int} month 
 * @returns monthsList = []
 */
let genMonthList = function(month){
    let monthsList = [];

    for(let monthIndex = month; monthIndex <= 12; monthIndex++){
        monthsList.push(monthIndex);
    }

    for(let monthIndex = 1; monthIndex < month; monthIndex++){
        monthsList.push(monthIndex);
    }

    return monthsList;
}

/**
 * 날짜 리스트 생성
 * @param {int} lastDayNum 마지막 날짜
 * @param {int} viewMonth 표출 달
 * @param {int} viewYear 표출 년
 * @returns {daysHeadLineList[], daysList[]}
 */
let genDayList = function(lastDayNum, viewMonth, viewYear){
    let daysList = [];
    let daysHeadLineList = [];
    let startDay = viewMonth == currentMonth ? currentDay : 1;

    //첫 요일 확인
    let newDate = new Date(viewYear + "-" + addZero(viewMonth) + "-" + addZero(1));
    let dayNum = newDate.getDay();

    //headline 날짜
    for(let dayIndex = 1; dayIndex <= lastDayNum; dayIndex++){
        daysHeadLineList.push(
            {
                day: dayIndex,
                text: transWord(dayNum),
                strDay: startDay
            }
        );
        dayNum = dayNum == 6 ? 0 : dayNum+1;
    }

    //현재 시각에 맞게 시작 날짜 변경, 일별 데이터
    newDate = new Date(viewYear + "-" + addZero(viewMonth) + "-" + addZero(startDay));
    dayNum = newDate.getDay();

    for(let dayIndex = startDay; dayIndex <= lastDayNum; dayIndex++){
        daysList.push(
            {
                day: dayIndex,
                text: transWord(dayNum),
                subject: "어초 침선 출조",
                fishType: "우럭",
                strTime: "04:00",
                endTime: "15:00",
                leftSeat: 16

            }
        );
        dayNum = dayNum == 6 ? 0 : dayNum+1;
    }

    return {daysHeadLineList, daysList};
}

/**
 * 숫자를 문자열로 변환하여 길이가 1인 경우 앞에 '0'을 붙여 반환
 * @param {int} num 
 * @returns string "00"
 */
function addZero(num) {
    return num < 10 ? '0' + num : num.toString();
}

/**
 * 요일 글자 변환
 * @param {int} dayNumber 
 * @returns string "월"
 */
let transWord = function (dayNumber) {
    let dayWord = "";
    switch (dayNumber) {
        case 0: dayWord = "일";
            break;
        case 1: dayWord = "월";
            break;
        case 2: dayWord = "화";
            break;
        case 3: dayWord = "수";
            break;
        case 4: dayWord = "목";
            break;
        case 5: dayWord = "금";
            break;
        case 6: dayWord = "토";
            break;
    }
    return dayWord;
}

/**
 * 받은 달의 날짜 리스트 생성
 * @param {int} month 
 * @param {int} year
 * @returns daysList[]
 */
let genDayListToMonth = function(month, year){    
    let days = daysInMonth(month, year);
    // console.log(`현재 달 ${currentMonth}월의 마지막 날짜는 ${days}일 입니다.`);
    return genDayList(days, month, year)
}

let dayListData = genDayListToMonth(viewMonth, currentYear)

//일별 데이터 삽입
// let dayList = genDayListToMonth(viewMonth, currentYear);
// dayList.forEach(function(data, i){
//     console.log("data")
// });


let dataset = {
    month : viewMonth,
    year: currentYear,
    monthList : genMonthList(currentMonth),
    dayList : dayListData.daysList,
    dayHeadLineList : dayListData.daysHeadLineList
}

let getBookingData = function(){
    return dataset;
}

export default {getBookingData}